<div class="row justify-content-center">
  <div class="col-12 col-lg-10 col-xl-8">

    <!-- Header -->
    <app-organization-header></app-organization-header>

    <div class="d-flex flex-row-reverse mb-4">
      @if (state == 'READY' && licenseStatus != 'SUSPENDED') {
        <a [routerLink]="'subscription/upgrade'"
          class="btn btn-primary">Mettre à
        niveau l'abonnement</a>
      }
    </div>


    <div class="row">
      <div class="col-6 col-md-3">

        <!-- Card -->
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col">

                <!-- Title -->
                <h6 class="text-uppercase text-muted mb-3">
                  État
                </h6>

                <!-- Heading -->
                @if (state == 'LOADING' || state == 'REFRESHING') {
                  <span class="h2 mb-0">
                    Chargement en cours...
                  </span>
                }
                @if (state == 'READY') {
                  <span class="h2 mb-0">
                    @if (licenseStatus == 'ACTIVE') {
                      <span
                      class="badge bg-primary-soft">Actif</span>
                    }
                    @if (licenseStatus == 'SUSPENDED') {
                      <span><span
                      class="badge text-bg-danger">Suspendu</span></span>
                    }
                    @if (licenseStatus == 'TRIAL_ENDED') {
                      <span class="badge text-bg-danger">Essai gratuit terminé</span>
                    }
                    @if (licenseStatus == 'TRIALING') {
                      <span
                      class="badge text-bg-warning">Essai gratuit</span>
                    }
                    @if (licenseStatus == 'UNLICENSED') {
                      <span class="badge text-bg-danger">Aucune licence</span>
                    }
                  </span>
                }

              </div>
              @if (state == 'READY' && licenseStatus == 'SUSPENDED') {
                <div class="col-auto">
                  <a class="btn btn-outline-primary btn-sm" href="">S'abonner</a>
                </div>
              }
            </div> <!-- / .row -->

          </div>
        </div>

      </div>
      <div class="col-6 col-md-5">

        <!-- Card -->
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col">

                <!-- Title -->
                <h6 class="text-uppercase text-muted mb-3">
                  Abonnement
                </h6>

                <!-- Heading -->
                @if (state == 'LOADING' || state == 'REFRESHING') {
                  <span class="h2 mb-0">
                    Chargement en cours...
                  </span>
                }
                @if (state == 'READY' && licenseType == 'INDIVIDUAL') {
                  <span class="h2 mb-0">1 utilisateur</span>
                }
                @if (state == 'READY' && licenseType == 'QUESTIONNAIRE') {
                  <span class="h2 mb-0">Questionnaire</span>
                }
                @if (state == 'READY' && licenseType == 'TEAM') {
                  <span
                  class="h2 mb-0">25 utilisateurs</span>
                }
                @if (state == 'READY' && licenseType == 'STUDENT') {
                  <span class="h2 mb-0">Version étudiante</span>
                }
              </div>
            </div> <!-- / .row -->

          </div>
        </div>

      </div>
      <div class="col-12 col-md-4">

        <!-- Card -->
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col">

                <!-- Title -->
                <h6 class="text-uppercase text-muted mb-3">
                  {{ this.secondColumnTitle }}
                </h6>

                <!-- Heading -->
                <span class="h2 mb-0">
                  {{ this.secondColumnHeading }}
                </span>

              </div>
            </div> <!-- / .row -->

          </div>
        </div>

      </div>
    </div>


    <!-- Card -->
    <div class="card">
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col">

            <!-- Title -->
            <h4 class="card-header-title">
              Méthodes de paiement
            </h4>

          </div>
          <div class="col-auto">

            <!-- Button -->
            <button (click)="showAddPaymentMethodModal()" class="btn btn-sm btn-primary">
              Ajouter
            </button>

          </div>
        </div>
      </div>
      <div class="card-body">
        @if (paymentMethodsState == 'LOADING' || paymentMethodsState == 'REFRESHING') {
          <div
            class="list-group list-group-flush my-n3">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Chargement...</span>
            </div>
          </div>
        }

        <!-- List group -->
        @if (paymentMethodsState == 'READY') {
          <div class="list-group list-group-flush my-n3">
            @if (paymentMethods.length === 0) {
              <div class="list-group-item">
                <div class="row align-items-center">
                  <div class="col text-center">
                    <h2>Vous n'avez aucune méthode de paiement à votre compte.</h2>
                    <button (click)="showAddPaymentMethodModal()"
                      class="btn btn-primary d-block m-auto"><i
                    class="fa fa-credit-card"></i> Ajouter une
                    méthode de paiement
                  </button>
                </div>
              </div>
            </div>
          }
          @for (paymentMethod of paymentMethods; track paymentMethod) {
            <div class="list-group-item">
              <div class="row align-items-center">
                <div class="col-auto">
                  @if (paymentMethod.brand === 'visa') {
                    <i class="fab fa-cc-visa fa-2x"></i>
                  }
                  @if (paymentMethod.brand === 'amex') {
                    <i class="fab fa-cc-amex fa-2x"></i>
                  }
                  @if (paymentMethod.brand === 'mastercard') {
                    <i class="fab fa-cc-mastercard fa-2x"></i>
                  }
                </div>
                <div class="col ms-n2">
                  <!-- Heading -->
                  <h4 class="mb-1">
                    {{ paymentMethod.brand | titlecase }} se terminant avec
                    {{ paymentMethod.last4 }}
                  </h4>
                  <!-- Text -->
                  <small class="text-muted">
                    Expire le {{ paymentMethod.expirationYear }}-{{ paymentMethod.expirationMonth }}
                  </small>
                </div>
                <div class="col-auto me-n3">
                  <!-- Badge -->
                  <!--                                <span class="badge bg-light">-->
                  <!--                          Default-->
                <!--                        </span>-->
              </div>
              <div class="col-auto">
                <!-- Dropdown -->
                <div class="dropdown">
                  <a aria-expanded="false" aria-haspopup="true" class="dropdown-ellipses dropdown-toggle"
                    data-bs-toggle="dropdown"
                    href="#" role="button">
                    <i class="fe fe-more-vertical"></i>
                  </a>
                  <div class="dropdown-menu dropdown-menu-end">
                    <button (click)="showDeletePaymentMethodModal(paymentMethod)"
                      class="dropdown-item text-danger">
                      Supprimer
                    </button>
                  </div>
                </div>
              </div>
            </div> <!-- / .row -->
          </div>
        }
      </div>
    }

  </div>
</div>

<!-- Card -->
<div class="card">
  <div class="card-header">

    <!-- Title -->
    <h4 class="card-header-title">
      Factures
    </h4>

  </div>
  <div class="table-responsive">
    <table class="table table-sm table-nowrap card-table">
      <thead>
        <tr>
          <th>Date</th>
          <th>Identifiant</th>
          <th>Montant</th>
          <th>État</th>
        </tr>
      </thead>
      <tbody class="fs-base">
        @if (invoicesState == 'LOADING' || invoicesState == 'REFRESHING') {
          <tr>
            <td colspan="4">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Chargement...</span>
              </div>
            </td>
          </tr>
        }
        @for (invoice of invoices; track invoice) {
          <tr>
            <td>
              <time datetime="2020-04-24">{{ invoice.periodEnd | date: 'yyyy-MM-dd' }}</time>
            </td>
            <td>{{ invoice.id }}</td>
            <td>
              {{ invoice.amount | currencyCents }}
            </td>
            <td>
              <span [class.bg-info]="invoice.status === 'open'"
                [class.bg-secondary]="invoice.status === 'draft'"
                [class.bg-success]="invoice.status === 'paid'"
                [class.bg-warning]="invoice.status === 'void'"
              class="badge">{{ invoice.status }}</span>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>

<!-- Text -->
<br>

</div>
</div> <!-- / .row -->